import { Grid, Typography, Stack, Pagination } from '@mui/material';
import Colors from '@src/app/config/colorConfig';
import { FC, useState } from 'react';
import AssetCard from './AssetCard';
import { holdingsUrl } from '@src/app/utils/UrlBuilder';
import { useHistory } from 'react-router-dom';
import { AssetCardDetails } from '@src/app/store/reducers/assetAllocation/types';
import { useAppDispatch } from '@src/app/hooks/store';
import { setHoldingFilters } from '@src/app/store/reducers/holdings';

const MAX_ASSET_CARDS_PER_PAGE = 10;

interface AssetCardContainerProps {
  assetCards: AssetCardDetails[];
}

const AssetCardContainer: FC<AssetCardContainerProps> = ({ assetCards }: AssetCardContainerProps): JSX.Element => {
  const [assetCardPage, setAssetCardPage] = useState<number>(1);
  const assetCardPages = Math.ceil(assetCards.length / MAX_ASSET_CARDS_PER_PAGE);
  const assetCardPageStart = (assetCardPage - 1) * MAX_ASSET_CARDS_PER_PAGE;
  const assetCardsOnPage = assetCards.slice(assetCardPageStart, assetCardPageStart + MAX_ASSET_CARDS_PER_PAGE);
  const assetCardsShowing = `Showing ${assetCardPageStart + 1} -
                  ${Math.min(assetCardPageStart + MAX_ASSET_CARDS_PER_PAGE, assetCards.length)} of
                  ${assetCards.length} entries`;
  const history = useHistory();
  const dispatch = useAppDispatch();

  const navigateToHoldings = () => {
    dispatch(setHoldingFilters([]));
    history.push(holdingsUrl());
  };

  return (
    <>
      {assetCardsOnPage.map((card, index) => (
        <AssetCard key={index} {...card} />
      ))}
      {assetCardPages > 1 && (
        <Grid item container justifyContent="space-between">
          <Grid item>
            <Typography fontWeight={500} color={Colors.gray800}>
              {assetCardsShowing}
            </Typography>
          </Grid>
          <Grid item>
            <Stack spacing={2}>
              <Pagination
                count={assetCardPages}
                page={assetCardPage}
                onChange={(_, page) => setAssetCardPage(page)}
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </Grid>
        </Grid>
      )}
      <Grid item alignSelf="flex-end">
        <Typography
          onClick={() => navigateToHoldings()}
          sx={{ textDecoration: 'underline', ':hover': { cursor: 'pointer' } }}
          fontWeight={700}
          color={'#4D1CFF'}
        >
          View all Holdings
        </Typography>
      </Grid>
    </>
  );
};

export default AssetCardContainer;
